import uploadIcon from "../../../assets/icons/uploadIcon.svg";
import { File } from "lucide-react";

const UploadFileInput = ({
  name,
  placeholder,
  accept,
  register,
  setValue,
  multiple,
  error,
  uploadedFile,
  removeUploadedFile,
}) => {
  const clickHandle = () => {
    // Set the value of the input to empty on each onclick event
    setValue(name, "");
  };
  return (
    <>
      <div
        className={`rounded-md border-bw border-dashed 2xs:max-sm:mt-3 bg-lb3 py-8 text-center ${
          error ? "border-red-500" : "border-dark-blue"
        }`}
      >
        {uploadedFile && uploadedFile[0]?.name ? (
          <>
            <File color="green" size={100} className="mx-auto"/>
            <p className="pl-2 max-lg:text-xs py-6">
              {uploadedFile[0]?.name}
            </p>
            <button
              onClick={removeUploadedFile}
              className="bg-lg5 text-red-600 px-3 py-1 rounded hover:bg-gray-300 max-lg:text-sm"
            >
              Remove File
            </button>
          </>
        ) : (
          <>
            <img src={uploadIcon} alt="upload icon" className="mx-auto max-lg:max-w-[60px]" />
            <p className="pl-2 max-lg:text-xs pt-3">Upload File Here</p>
            <p className="pl-2 max-lg:text-xs text-lg3">
              Format {placeholder}
            </p>
            <div className="max-w-[180px] mx-auto relative pt-4">
              <input
                type="file"
                name={name}
                className="opacity-0 z-55 absolute cursor-pointer left-0"
                accept={accept}
                {...register}
                onClick={setValue ? clickHandle : undefined}
                multiple={multiple}
              />
              <p className="rounded-md py-2 px-3 cursor-pointer bg-dark-blue text-white border-dark-blue border-1 max-lg:text-sm">
                Choose File
              </p>
            </div>
          </>
        )}
      </div>
      <p
        className={`text-red-500 font-figtree text-xs h-4 ${
          error ? "visible" : "invisible"
        }`}
      >
        {error?.message}
      </p>
    </>
  );
};

export default UploadFileInput;
